import { render, staticRenderFns } from "./AddCollCustomer.vue?vue&type=template&id=df8d31b6&scoped=true"
import script from "./AddCollCustomer.vue?vue&type=script&lang=js"
export * from "./AddCollCustomer.vue?vue&type=script&lang=js"
import style0 from "./AddCollCustomer.vue?vue&type=style&index=0&id=df8d31b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8d31b6",
  null
  
)

export default component.exports